import React, { useMemo } from 'react';
import { useProjectPermissions } from '@atlassian/jira-project-permissions-service/src/main.tsx';
import { useProjectKey, useIssueKey } from '@atlassian/jira-issue-context-service/src/index.tsx';
import { useProjectConfiguration } from '@atlassian/jira-project-context-service/src/main.tsx';
import { FLAG_ACTIONS } from '@atlassian/jira-issue-view-configurations/src/index.tsx';
import type { Attributes } from '@atlassian/jira-product-analytics-bridge';
import { useFlaggedField } from '@atlassian/jira-issue-field-flagged/src/services/main.tsx';
import { useSearchCustomFieldKeys } from '@atlassian/jira-issue-field-base/src/services/custom-field-key-service/index.tsx';
import { FLAGGED_CF_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { VoteButton } from '../vote-issue/main.tsx';
import { FlagIssueActionView } from '../add-to-issue-dropdown-group/flag/main.tsx';
import { addFlagLabel, removeFlagLabel } from '../add-to-issue-dropdown-group/flag/index.tsx';

export const AddtoIssueActionGroup = (
	onClick: (
		itemKey: string,
		event?: Event,
		actionAttributes?: Attributes,
	) => Promise<undefined> | undefined,
) => {
	const { formatMessage } = useIntl();
	const projectKey = useProjectKey();
	const issueKey = useIssueKey();
	const [permissions] = useProjectPermissions(projectKey);
	const [fieldKey] = useSearchCustomFieldKeys(issueKey, FLAGGED_CF_TYPE);
	const { issueActions } = useProjectConfiguration(projectKey);
	const shouldShowFlag = useMemo(
		() => permissions.canEditIssues && !!issueActions?.includes(FLAG_ACTIONS),
		[permissions, issueActions],
	);
	const [{ value: isFlagged }] = useFlaggedField({ issueKey, fieldKey: fieldKey || '' });
	return {
		name: '',
		key: 'addtoIssueActionGroup',
		items: [
			...(shouldShowFlag
				? [
						<FlagIssueActionView
							key="flagIssue"
							onClick={onClick}
							itemKey="flagIssue"
							label={formatMessage(isFlagged ? removeFlagLabel : addFlagLabel)}
						/>,
					]
				: []),
			<VoteButton key="vote" />,
		],
	};
};
